export const contato = {
  email: "contato@precatoriosbrasil.com",
  telefoneComDDD: "553330388051"
};

export const phoneMask = (value) => {
  const str = value.replace("5533", "(33) ");
  const str1 = str.split(" ")[0];
  const str2 = str.split(" ")[1];
  const str3 = str2.replace(str2.substring(0, 4), `${str2.substring(0, 4)}-`);
  return str1 + " " + str3;
};
